// Money / currency display helpers for the Rajbet65 app.
// Numbers in the DB are stored as raw floats; this layer adds the
// Indian Rupee symbol and en-IN comma grouping for display only.

const SYMBOL = "₹"; // ₹

const toNumber = (v) => {
  if (v === null || v === undefined || v === "") return 0;
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

// Format a money value with the rupee symbol and en-IN grouping.
// Pass { showSymbol: false } to get a comma-grouped number with no symbol.
export const formatINR = (value, opts = {}) => {
  const { showSymbol = true, fractionDigits } = opts;
  const n = toNumber(value);
  const negative = n < 0;
  const abs = Math.abs(n);
  const grouped = abs.toLocaleString("en-IN", {
    minimumFractionDigits:
      fractionDigits !== undefined
        ? fractionDigits
        : abs % 1 === 0
        ? 0
        : 2,
    maximumFractionDigits: fractionDigits !== undefined ? fractionDigits : 2,
  });
  return (negative ? "-" : "") + (showSymbol ? SYMBOL : "") + grouped;
};

export const rupeeSymbol = SYMBOL;
